import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../lib/reacti18n';

const error = {
  message: i18n.message('smarthelp/Error.error.message'),
  tryAgain: i18n.message('smarthelp/Error.error.tryAgain'),
};

const Error = function (props) {
  return (
    <div className="error-block-container">
      <div className="vx_icon vx_icon-large vx_icon-critical-large" aria-hidden="true" />
      <div id="test_id_error_message" className="vx_text-1 error-msg">
        {props.message}
      </div>
      <div id="test_id_error_tryagain" className="vx_text-3  error-inst">
        {props.tryAgain}
      </div>
    </div>
  );
};

Error.propTypes = {
  tryAgain: PropTypes.string,
  message: PropTypes.string,
};

Error.defaultProps = {
  tryAgain: error.tryAgain,
  message: error.message,
};

export default Error;
